import { createContext, useContext } from 'react';

export const SterilizerCycleInfoContext = createContext({});
export const useSterilizerCycleInfo = () => {
	const sterilizerCycleInfo = useContext(SterilizerCycleInfoContext);
	return sterilizerCycleInfo;
};

export default SterilizerCycleInfoContext.Provider;
